import { CwtApiEntity, CwtProp, CwtSchema } from "@cawita/core-front/api";
import { Company } from "./company.model";

export class CompanyApiEntity extends CwtApiEntity {
    @CwtProp({ ref: Company }) company: Company;
}